import React from 'react';
import { IFile } from '@ui/hooks/file/types';
import { Minus, Play } from 'lucide-react';
import { twMerge } from 'tailwind-merge';
import { useImagePreviewContext } from '@ui/hooks/file/ImagePreviewContext';

interface FilePreviewProps {
  className?: string;
  file: IFile;
  onDelete: (id: string) => void;
}

export const FilePreview: React.FC<FilePreviewProps> = ({ file, onDelete, className }) => {
  const isVideo = Boolean(file.meta?.mime_type?.startsWith('video/'));
  const { setMediaPreview } = useImagePreviewContext();

  const handlePreviewClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setMediaPreview(file.src, isVideo);
  };

  const handleDeleteClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onDelete(file.id);
  };

  return (
    <div className="relative">
      <div
        className="relative cursor-pointer hover:opacity-90 transition-opacity"
        onClick={handlePreviewClick}>
        {isVideo ? (
          <>
            <video
              src={file.src}
              className={twMerge('h-8 w-8 rounded-sm object-cover', className)}
              muted
            />
            {/* Video play icon overlay */}
            <div className="absolute inset-0 flex items-center justify-center bg-black/30 rounded-sm pointer-events-none">
              <Play className="h-4 w-4 text-white fill-white" />
            </div>
          </>
        ) : (
          <img
            src={file.src}
            width={80}
            height={80}
            className={twMerge('h-8 w-8 rounded-sm object-cover', className)}
            alt="preview"
          />
        )}
        <Minus
          onClick={handleDeleteClick}
          className="text-primary bg-secondaryHover absolute -right-1 -top-2 h-4 w-4 cursor-pointer rounded-md text-xs z-10 hover:bg-red-100"
        />
      </div>
    </div>
  );
};
